import React from 'react';
import KickImage from 'Reuseables/KickImage';
import HamburgerMenu from '../../Atoms/HamburgerMenu';

import { IMenuButtonContainerProps } from './MenuButtonContainer.definitions';

/** CSS import */
import Styles from './MenuButtonContainer.module.scss';

const MenuButtonContainer: React.FC<IMenuButtonContainerProps> = ({
  onOpen,
}: IMenuButtonContainerProps) => {
  return (
    <div className={Styles['blog-menu']} onClick={onOpen}>
      <HamburgerMenu />
    </div>
  );
};

export default MenuButtonContainer;
